import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
/**
 * Pablo 28-11-19
 */
export class AppTitleService {

  constructor() { }

  getTitle(idSubSector, titulo, opcion, readonly?: boolean) {
    let title = "";
    let option = "";
    if (idSubSector == "SUB00005") {
      title = titulo;
    } else {
      switch (opcion) {
        // case "AGREGAR":
        //   option = "AGREGAR";
        //   break;
        case "MODIFICAR":
          option = "MODIFICAR";
          if (readonly == true) {
            option = "";
          }
          break;
        case "ELIMINAR":
          option = "ELIMINAR";
          break;
        case "ENVIAR":
          option = "ENVIAR";
          break;
      }
      if (option != "") {
        title = option + " " + titulo
      } else {
        title = titulo
      }
    }
    return title;
  }
}
